import React from 'react';
import * as Collections from './collections';

class Provider extends React.Component {

  render() {
    return (
      <Collections.AppCollection.Provider>
        <Collections.CustomerCollection.Provider>
          <Collections.LocationCollection.Provider>
            <Collections.PendingProductInstanceCollection.Provider>
              <Collections.ProductInstanceCollection.Provider>
                <Collections.UserCollection.Provider>
                  <Collections.ProductVersionsCollection.Provider>
                    {this.props.children}
                  </Collections.ProductVersionsCollection.Provider>
                </Collections.UserCollection.Provider>
              </Collections.ProductInstanceCollection.Provider>
            </Collections.PendingProductInstanceCollection.Provider>
          </Collections.LocationCollection.Provider>
        </Collections.CustomerCollection.Provider>
      </Collections.AppCollection.Provider>
    )
  }

}

export default Provider;



// WEBPACK FOOTER //
// ./src/services/collection/provider.js